<div class="text-widget-navigation-n">
  <div
    *ngIf="hasOptions"
    class="options-panel"
    [style.grid-template-columns]="buttonsGridTemplateColumns"
    [style.gap]="optionsGap"
  >
    <button
      *ngFor="let option of navigationOptions; trackBy: trackByIndex"
      type="button"
      class="option-btn"
      [disabled]="option.disabled"
      [style.background-color]="getOptionBackgroundColor(option)"
      [style.color]="getOptionTextColor(option)"
      [style.border-color]="getOptionBorderColor(option)"
      [style.border-width]="getOptionBorderWidth(option)"
      [style.border-radius]="getOptionBorderRadius(option)"
      [style.box-shadow]="getOptionBoxShadow(option)"
      [style.padding]="getOptionPadding(option)"
      [style.min-height]="getOptionMinHeight(option)"
      [style.min-width]="getOptionMinWidth(option)"
      [style.width]="getOptionWidth(option)"
      [style.font-size]="getOptionFontSize(option)"
      [style.font-weight]="getOptionFontWeight(option)"
      [style.font-style]="getOptionFontStyle(option)"
      [style.font-family]="getOptionFontFamily(option)"
      (click)="onOptionClick(option, $event)"
    >
      <span class="card-shell">
        <span class="card-top-row">
          <span class="card-top-left">
            <span class="card-top-icon-wrap" *ngIf="getOptionTopIcon(option)">
              <img *ngIf="isImageIcon(getOptionTopIcon(option)); else optionTopMatIcon" class="card-top-icon-image" [src]="getOptionTopIcon(option)" alt="" />
              <ng-template #optionTopMatIcon>
                <mat-icon class="card-top-icon">{{ getOptionTopIcon(option) }}</mat-icon>
              </ng-template>
            </span>

            <span *ngIf="getOptionModuleLabel(option)" class="card-module-label">
              {{ getOptionModuleLabel(option) }}
            </span>
          </span>
        </span>

        <span class="card-title">
          {{ formatOptionLabel(option) }}
        </span>

        <span *ngIf="getOptionSubtitle(option)" class="card-subtitle">
          {{ getOptionSubtitle(option) }}
        </span>

        <span class="card-divider"></span>

        <span class="card-bottom-icon-wrap" *ngIf="getOptionBottomIcon(option)">
          <img *ngIf="isImageIcon(getOptionBottomIcon(option)); else optionBottomMatIcon" class="card-bottom-icon-image" [src]="getOptionBottomIcon(option)" alt="" />
          <ng-template #optionBottomMatIcon>
            <mat-icon class="card-bottom-icon">{{ getOptionBottomIcon(option) }}</mat-icon>
          </ng-template>
        </span>
      </span>
    </button>
  </div>
</div>
